import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Indicator } from 'src/app/core/_models/indicator';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-dialog-scenario',
  templateUrl: './dialog-scenario.component.html',
  styleUrls: ['./dialog-scenario.component.scss']
})
export class DialogScenarioComponent {
  form!: FormGroup;
  constructor(
    public dialogRef: MatDialogRef<DialogScenarioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = new FormGroup({});
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  valueChange(indicators: Indicator[], item: Indicator, $event: any): void {
    //indicators[item].isChecked = $event.checked;
    indicators.forEach((currentIndicator) => {
      if (currentIndicator && currentIndicator.indicatorId == item.indicatorId) {
        currentIndicator.isChecked = $event.checked;
      }
    });
  }
}
